/* eslint-disable no-unused-vars */
import { call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import moment from 'moment';
// @ts-ignore
import pt from 'moment/locale/pt-br';
import { Response, UserState } from '../../../interfaces';
import axiosServices from '../../../services/axiosServicesLogin';
import store from '../..';
import { setLoadingLogin, setLoginIsErrorMessage, setUser } from './actions';

const instance = axiosServices;

export function* signIn({ payload }: {
  payload: {
    token: string;
    login: string
  }
}): any {
  try {
    const { token, login } = payload;

    store.dispatch(setLoadingLogin(true));
    store.dispatch(setLoginIsErrorMessage(false));

    const response: Response = yield call(instance.post, 'admin/conta-usuario/v1/gerar-token', {
      tokenAd: token,
    });

    const data: UserState = {
      id: response?.data?.usuario.userId,
      token: response?.data?.token?.access_token,
      login,
      name: response?.data?.usuario.name,
      userName: response?.data?.usuario.userName,
      signed: true,
      loading: false,
      errorMessage: '',
      isError: false,
      avatar: response?.data?.usuario.urlFoto !== null ? response?.data?.usuario.urlFoto : '',
      password: '',
      permissoes: response?.data?.usuario.permissoes,
    };

    const dataToRefres = {
      refreshToken: response.data.token.refresh_token,
      token: response?.data?.token?.access_token,
    };

    localStorage.setItem('@token', JSON.stringify(dataToRefres));

    store.dispatch(setUser(data));
    store.dispatch(setLoadingLogin(false));
  } catch (err: any) {
    if (err.status === 500) {
      store.dispatch(setLoginIsErrorMessage(true));
      store.dispatch(setLoadingLogin(false));
    } else {
      toast.error(`⚠ ${err?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
      store.dispatch(setLoginIsErrorMessage(true));
      store.dispatch(setLoadingLogin(false));
    }
  }
}
